import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../../store";
import { addInsuranceOfferResponse } from "../modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    loading: state.insuranceRequestDetailsReducer.loading,
    requestDetails: state.insuranceRequestDetailsReducer.requestDetails,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      addInsuranceOfferResponse,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
